export default __webpack_public_path__ + "static/media/Banner.ef53d92a.jpg";